<template>
  <div>
    <v-container fill-height fluid grid-list-xl>
      <Loader  v-if="loading" :loading="loading" />
      <v-layout v-else justify-center wrap>
        <v-flex md12>
          <v-btn color="success" class="mr-2" @click="saveTournaments()" text>Сохранить</v-btn>
        <multiselect
                v-model="participant"
                tag-placeholder="Выберете или напишите новый"
                selectedLabel="Применен"
                placeholder="Вставьте артикулы"
                :showLabels="false"
                label="vendor_code"
                track-by="id"
                @input="setProduct"
                :loading="findLoading"
                :options="vendor_codes"
                :taggable="false"
                :multiple="false"
                @search-change="asyncFind"
          ></multiselect>
          <br />
          <br />
          <v-data-table :headers="headers" :items="products" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>

            <template slot="items" slot-scope="{ item }">
              <td class="text-xs-left">
                <img
                  v-if="item.images && item.images.length"
                  width="90"
                  :src="item.images[0].image_medium"
                  alt
                />
              </td>
              <td class="text-xs-left">
                <v-text-field type="number" v-model="item.iteration" label="Итераций"></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field type="number" v-model="item.percent" label="Бонус"></v-text-field>
              </td>
              <td class="text-xs-left">
                <b>{{ item.vendor_code }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.options_count }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ item.title }}</b>
              </td>
              <td class="text-xs-right">
                <v-icon class="mr-2 text-danger" @click="removeItem(item)">mdi-close</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";

export default {
  data: () => ({
    products: [],
    vendor_codes: [],
    participant: {},
    loading: true,
       findLoading: false,
    headers: [
      {
        sortable: false,
        text: "Изображение",
        value: "id"
      },
      {
        sortable: false,
        text: "Количество итераций",
        value: "id"
      },
      {
        sortable: false,
        text: "Бонус",
        value: "id"
      },
      {
        sortable: false,
        text: "Артикул",
        value: "dealer.name"
      },
      {
        sortable: false,
        text: "Количество активаций",
        value: "dealer.options_count"
      },
      {
        sortable: false,
        text: "Наименование",
        value: "dealer.name"
      },
      {
        sortable: false,
        text: "",
        value: "dealer.name"
      }
    ]
  }),
  components: { Loader },
  methods: {
    removeItem(item) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === item.id) {
          this.products.splice(i, 1);
        }
      }
    },
    getProducts() {
      axios
        .get("admin/tournaments/products/" + this.Tournament_id)
        .then(response => {
          this.products = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    },
    saveTournaments() {
      this.loading = true;
      axios
        .post("admin/tournaments/set/products", {
          id: this.Tournament_id,
          items: this.products
        })
        .then(response => {
            this.getProducts();
        })
        .finally(() => {
        //   setTimeout(() => {
        //     this.loading = false;
        //   }, 400);
        });
    },

     asyncFind(query) {
      this.findLoading = true;
      axios
        .get("admin/products/search", {
          params: {
            search: query
          }
        })
        .then(response => {
          this.vendor_codes = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.findLoading = false;
          }, 400);
        });
    },

    setProduct(val){
        this.participant = {};

          let access = true;
            for(let i= 0;i<this.products.length;i++){
                if (this.products[i].id===val.id){
                    access = false;
                }
            }  
        if (access){
             this.$toast.success({
              title: "Новый товар",
              message: "Прикреплен"
            });
            this.products.unshift({
                id: val.id,
                vendor_code:val.vendor_code,
                percent:0,
                iteration:0,
                title:'Несохраненный товар'
            });
        }
  
    }
  },
  computed: {
    Tournament_id: {
      get() {
        return this.TournamentID;
      },
      set(val) {}
    }
  },
  props: ["TournamentID"],
  mounted() {
    this.getProducts();
  }
};
</script>
